import React from 'react';
import Icon from '../../../Symbols/Icon';
const IconMinus = ({ size, fill, ...commonProps }) => {
    const iconContent = {
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M5.25 12.75C4.836 12.75 4.5 12.414 4.5 12C4.5 11.586 4.836 11.25 5.25 11.25H18.75C19.164 11.25 19.5 11.586 19.5 12C19.5 12.414 19.164 12.75 18.75 12.75H5.25Z", fill: "black" }))),
        alt: 'Minus',
    };
    return React.createElement(Icon, { ...commonProps, source: iconContent, size: size, fill: fill });
};
IconMinus.displayName = 'IconMinus';
export default IconMinus;
//# sourceMappingURL=index.js.map